import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "572",
  height: "248",
  viewBox: "0 0 572 248",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect x=\"98.5\" y=\"44\" width=\"375\" height=\"160\" rx=\"16\" fill=\"var(--dt-color-surface-primary)\"></rect><rect x=\"99.5\" y=\"45\" width=\"373\" height=\"158\" rx=\"15\" stroke=\"var(--dt-color-border-bold)\" stroke-opacity=\"0.5\" stroke-width=\"2\"></rect><g opacity=\"0.8\"><rect x=\"122.5\" y=\"68\" width=\"171\" height=\"24\" rx=\"12\" fill=\"var(--dt-color-foreground-placeholder)\"></rect><rect x=\"122.5\" y=\"108\" width=\"227\" height=\"16\" rx=\"8\" fill=\"var(--dt-color-surface-moderate)\"></rect></g><rect x=\"122.5\" y=\"150\" width=\"158\" height=\"30\" rx=\"7\" fill=\"var(--dt-color-surface-moderate)\"></rect><rect x=\"291.5\" y=\"150\" width=\"158\" height=\"30\" rx=\"7\" fill=\"var(--dt-action-color-background-base-primary-default)\"></rect>", 5)
  ]))]))
}
export default { render: render }